import admin from './admin';
import guest from './guest';
import user from './user';
import common from './common';
import pub from './pub';

export default {
  admin,
  guest,
  user,
  common,
  pub,
};
